module.exports = __webpack_public_path__ + "static/img/address-bg.09230dbd.png";